// src/LoadingScreen.js
import React, { useEffect, useState } from "react";
import "./LoadingScreen.css"; // Create this CSS file for styling

const LoadingScreen = ({ progress }) => {
  const [progressPercent, setProgressPercent] = useState(0);
  useEffect(() => {
    if (progress) setProgressPercent(Math.floor(progress * 100));
  }, [progress]);
  return (
    <div className="loading-screen">
      <div className="spinner"></div>
      {progressPercent > 0 && <span>{progressPercent + " %"}</span>}
    </div>
  );
};

export default LoadingScreen;
